const SurchargeApplicableProducts = [];

export { SurchargeApplicableProducts };
//# sourceMappingURL=src-constants-SurchargeApplicableProducts.js.map
